module.exports = __webpack_public_path__ + "static/media/ibanfirst-logo-single.63f81a95.svg";